import React from 'react'

// [system] Alert shown on POS when customer QR session expires — must dismiss manually
export default function QrExpiredAlert({ data, onClose }) {
  if (!data) return null

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ zIndex: 9999, background: 'rgba(0,0,0,0.5)' }}
    >
      <div
        className="d-flex flex-column align-items-center rounded-4 shadow-lg"
        style={{ background: '#fff', minWidth: 340, maxWidth: 420, padding: '36px 32px 28px' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* icon circle */}
        <div
          className="d-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{ width: 88, height: 88, background: '#FEF2F2', flexShrink: 0 }}
        >
          <svg width={44} height={44} viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>

        {/* label */}
        <p className="fw-bold mb-1" style={{ fontSize: 20, color: '#EF4444', margin: 0 }}>
          QR หมดเวลา
        </p>

        {/* table name */}
        <p style={{ fontSize: 15, color: '#6b7280', margin: '6px 0 28px' }}>
          {data.tableName || data.tableId}
        </p>

        <button
          className="btn w-100 fw-semibold rounded-3 py-2"
          style={{ background: '#EF4444', color: '#fff', fontSize: 15 }}
          onClick={onClose}
        >
          รับทราบ
        </button>
      </div>
    </div>
  )
}
// =====================[QrExpiredAlert]=====================
